<template>
  <svg viewBox="0 0 0 0" class="w-0 h-0">
    <filter id="round-lg">
      <feGaussianBlur in="SourceGraphic" stdDeviation="20" result="blur" />
      <feColorMatrix
        in="blur"
        mode="matrix"
        values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 19 -9"
        result="goo"
      />
      <feComposite in="SourceGraphic" in2="goo" operator="atop" />
    </filter>
    <filter id="round-md">
      <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
      <feColorMatrix
        in="blur"
        mode="matrix"
        values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 19 -9"
        result="goo"
      />
      <feComposite in="SourceGraphic" in2="goo" operator="atop" />
    </filter>
    <filter id="round-sm">
      <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
      <feColorMatrix
        in="blur"
        mode="matrix"
        values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 19 -9"
        result="goo"
      />
      <feComposite in="SourceGraphic" in2="goo" operator="atop" />
    </filter>
  </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "RoundFilterUtils",
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
});
</script>

<style>
.rounded-content-sm {
  filter: url(#round-sm);
}

.rounded-content-md {
  filter: url(#round-md);
}

.rounded-content-lg {
  filter: url(#round-lg);
}
</style>
